export default {
  currentMarkers:[],
  latLong: null,
  currentFeature: {}, // TODO INSERIR TODA A LEGENDA AQUI
  allFeatures: [],
  isDrawing: false,
  featureState: null
}
